import { DateTime } from "luxon";
import { type TranslatedString, untranslated } from "@Helpers/types/i18n";

export interface PortalDashboardDate {
  date: string;
  day: string;
  time: string;
  timeZone: string;
}

function convertDate(date: any, dateFormat: "dateForPortalDashboard", timeZone?: any): PortalDashboardDate;
// eslint-disable-next-line no-redeclare
function convertDate(date: any, dateFormat: string, timeZone?: any): TranslatedString;
// eslint-disable-next-line no-redeclare
function convertDate(date: any, dateFormat: any, timeZone?: any): TranslatedString | PortalDashboardDate {
  if (!date || isNaN(Number(date))) {
    return untranslated("");
  }
  const time = DateTime.fromMillis(Number(date));

  // Special case for portal dashboard - returns object
  if (dateFormat === "dateForPortalDashboard") {
    return {
      date: time.toFormat("dd MMM yy"),
      day: time.toFormat("cccc"),
      time: time.toFormat("hh:mm:ss a"),
      timeZone: time.toFormat("ZZ"),
    };
  }

  const formatMap: Record<string, () => string | null> = {
    dateForText: () => `${time.toFormat("MMM dd")} at ${time.toFormat("hh:mm a")}`,
    dateForTooltip: () => `${time.toFormat("MMM dd,yyyy")} at ${time.toFormat("hh:mm:ss a")}`,
    dateForProfile: () => time.toFormat("MMM dd, yyyy"),
    dateForOrganization: () => time.toFormat("MMM dd, yyyy"),
    NormalDate: () => time.toFormat("dd/MM/yyyy"),
    NormalDateTime: () => time.toFormat("MM/dd/yyyy hh:mm a"),
    getDifferenceTime: () => time.toRelative(),
    dateForToolTipModal: () => time.toFormat("MMM dd, yyyy"),
    dateForTooltipSpaceBeforeYear: () => `${time.toFormat("MMM dd, yyyy")} at ${time.toFormat("hh:mm:ss a")}`,
    dateForSignHistory: () => time.toFormat("MMM dd hh:mm a"),
    standardIsoFormat: () => time.toISO(),
    dateForPdfExport: () => `${time.toFormat("MMM dd, yyyy")} at ${time.toFormat("hh:mm a")}`,
    dateForSchedule: () => {
      const timeWithTimezone = timeZone ? time.setZone(timeZone) : time;
      return `${timeWithTimezone.toFormat("MMM dd, yyyy")} at ${timeWithTimezone.toFormat("hh:mm a")}`;
    },
    dateforProjectDashbaord: () => `${time.toFormat("dd MMM, yy")} ${time.toFormat("hh:mm a")}`,
    chatBot: () => `At ${time.toFormat("hh:mm a")}`,
  };

  const defaultFormat = () => time.toFormat(dateFormat);
  const formatter = formatMap[dateFormat] || defaultFormat;

  return untranslated(formatter() ?? "");
}

export { convertDate };
